














































































import { Vue, Component, Ref } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import SelectTree from "@/components/selectTree.vue"
import manageService from "@/services/manage.service"
import { FormModel } from "ant-design-vue"
import { NoticeList } from "./constant"
@Component({
    components: {
        PageHeader,
        SelectTree
    }
})
export default class IterationList extends Vue {
    product_version_id: number = null
    detailInfo: any = {}
    noticeInfo: any = {}

    form: any = {
        cc_uids: [],
        other_info: "",
        product_version_id: "",
        version_code: "",
        version_name: ""
    }

    labelCol = { span: 4 }
    wrapperCol = { span: 12 }

    get productName() {
        const { full_name } = this.detailInfo
        return `${full_name || "-"}`
    }

    get rules() {
        return {
            version_name: [{ required: true, message: "请输入VersionName", trigger: "blur" }],
            lock_time: [{ required: true, message: "请选择锁板时间", trigger: "change" }]
        }
    }

    get noticeList() {
        return NoticeList
    }

    @Ref("ruleForm")
    refFrom: FormModel

    async created() {
        this.product_version_id = Number(this.$route.query.id)
        await this.getDetail()
        this.getMemberInfo()
    }

    goBack() {
        this.$router.go(-1)
    }

    async getDetail() {
        try {
            const res: any = await manageService.getVersionDetail({
                product_version_id: this.product_version_id
            })
            this.detailInfo = res || {}
        } catch (error) {
            this.$message.error(`${error},获取详情失败！`)
        }
    }
    btnLoading = false
    async submit() {
        try {
            await this.refFrom.validate()
            this.$confirm({
                title: "请确认是否进行锁版？",
                onOk: () => {
                    this.lockVersion()
                }
            })
        } catch (error) {
            if (error) {
                this.$message.error(`${error}`)
            }
        }
    }
    async lockVersion() {
        try {
            this.btnLoading = true
            await manageService.lockVersion({
                ...this.form,
                product_version_id: this.product_version_id
            })
            this.$message.success(`锁版提交成功！`)
            window.history.go(-1)
        } catch (error) {
            this.$message.error(`${error}，锁版提交失败！`)
        } finally {
            this.btnLoading = false
        }
    }
    async getMemberInfo() {
        try {
            const res = await manageService.getMemberInfo({
                product_id: this.detailInfo.product_id,
                software_id: this.detailInfo.software_id
            })
            this.noticeInfo = res || {}
        } catch (error) {
            this.$message.error(`${error}`)
        }
    }
}
